/**
 * 실행 기록 알림 — 기록을 모르거나(조회 중·실패) 앞서 읽은 것이 최신이 아닐 때 화면이 하는 말의 정본, 그리고 읽은 기록이 비었을 때의 말.
 * 모르는 것을 0 건·빈 표로 그리지 않고, 앞서 읽은 목록을 보이면서 «불러오지 못했다» 고만 하지 않는다.
 * 기록 목록을 보이는 화면 — 프로젝트 홈·모델 홈의 기록 표(퀵 실행 이력도 같은 표), 실행 목록, 분석 화면의 기록 패널, 플랫폼 홈의 최근 활동,
 * 재시작 원본 고르기 — 가 같은 판정·같은 말을 쓴다(D-108).
 */
export type RunHistoryNoticeState = 'loading' | 'failed' | 'stale';

export const RUN_HISTORY_NOTICE: Record<RunHistoryNoticeState, { text: string; color: string }> = {
  loading: { text: '시뮬레이션 기록을 불러오는 중…', color: 'text.secondary' },
  failed: { text: '시뮬레이션 기록을 불러오지 못했습니다', color: 'error' },
  stale: { text: '시뮬레이션 기록을 새로 불러오지 못했습니다 — 앞서 불러온 기록을 보이고 있습니다', color: 'warning.main' },
};

/**
 * 기록 목록 자리의 판정 — 알림 하나와 «목록(또는 빈 목록의 말)을 그리는가» 를 함께 정한다. 한 자리에 두 말(«앞서 불러온 기록을 보이고 있다» 와
 * «기록이 없다», 또는 빈 자리)이 서지 않게.
 *  - rows: 지금 키(프로젝트·사용자)로 앞서 읽은 기록 수 — 모르면 null
 *  - failed: 마지막 조회가 실패했는가
 *  - refreshing: 다시 읽는 중인가
 * 다시 읽는 중이면 지난 실패는 지난 일이다 — 행이 있으면 알리지 않고(행을 알림으로 바꾸지 않는다 — #37), 없거나 비었으면 «불러오는 중».
 * 실패했는데 앞서 읽은 기록이 있으면 «새로 불러오지 못했다»(목록은 그대로), 없거나 비었으면 «불러오지 못했다»(보일 목록이 없다). 모르면 «불러오는 중».
 */
export function runHistoryView({ rows, failed, refreshing = false }: { rows: number | null; failed: boolean; refreshing?: boolean }): {
  notice: RunHistoryNoticeState | null;
  listed: boolean;
} {
  const notice: RunHistoryNoticeState | null = refreshing
    ? (rows ? null : 'loading')
    : failed ? (rows ? 'stale' : 'failed') : rows === null ? 'loading' : null;
  return { notice, listed: notice === null || notice === 'stale' };
}

/** 읽은 기록이 비었을 때의 말(`listed` 이고 0 건일 때) — 화면은 그 옆에 저마다의 안내(무엇을 하면 생기는가)를 붙일 수 있다 */
export const RUN_HISTORY_EMPTY_TEXT = '아직 시뮬레이션 기록이 없습니다';
